{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Fargevelger",
  "colorSwatch": "fargekart",
  "transparent": "gjennomsiktig",
  "twoDimensionalSlider": "2D-glidebryter"
}
